import { render, staticRenderFns } from "./AgendaPanelBody.vue?vue&type=template&id=2cffb910&scoped=true"
import script from "./AgendaPanelBody.vue?vue&type=script&lang=js"
export * from "./AgendaPanelBody.vue?vue&type=script&lang=js"
import style0 from "./AgendaPanelBody.vue?vue&type=style&index=0&id=2cffb910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffb910",
  null
  
)

export default component.exports